/* eslint-disable jsx-a11y/label-has-for */
// node modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';

// app modules: components
import SpinnerButton from 'components/SpinnerButton';
import Icon from 'components/Icon';

// app modules: constants
import { COLOURS } from 'constants/index';

// assets
import CssSocialLoginButtons from './SocialLoginButtons.scss';

export class SocialLoginButtonsComponent extends PureComponent {
  static propTypes = {
    onSocialButtonClick: PropTypes.func.isRequired,
    inProgress: PropTypes.string,
  };

  static defaultProps = {
    inProgress: null,
  };

  render() {
    const { onSocialButtonClick, inProgress } = this.props;
    return (
      <ul className="social-login__actions">
        <li className="social-login__action">
          <SpinnerButton
            text={<Icon fill={COLOURS.WHITE} name="facebook" height="20" width="20" />}
            loading={inProgress === 'facebook'}
            className="social-login__action__button button--block"
            themeName="royal"
            size="extra-large"
            onClick={() => onSocialButtonClick('facebook')}
          />
        </li>
        <li className="social-login__action">
          <SpinnerButton
            text={
              <img src="images/signup-with-apple-logo.png" height="40" alt="Sign up with Apple" />
            }
            loading={inProgress === 'apple'}
            onClick={() => onSocialButtonClick('apple')}
            className="social-login__action__button button--block"
            themeName="dark"
            themeType=""
            size="extra-large"
          />
        </li>
      </ul>
    );
  }
}

export default withStyles(CssSocialLoginButtons)(SocialLoginButtonsComponent);
